"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnprocessableEntity = void 0;
const ApiException_1 = require("./ApiException");
class UnprocessableEntity extends ApiException_1.ApiException {
    constructor(message = 'Unprocessable entity.', data) {
        super(message, data);
    }
}
exports.UnprocessableEntity = UnprocessableEntity;
